import React, { useState, useEffect, useMemo } from "react";
import classnames from "classnames";
import {
  Card, CardBody, Col, Container, Row, Nav, NavItem, NavLink,
  TabContent, TabPane, Label, Input, Button, Spinner, FormGroup, Alert, Badge
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const Hesabim = () => {
  document.title = "Hesabım | HarmanaGEL";

  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const userId = authUser?.ID;
  const hesapTuru = authUser?.HESAP_TURU || "";
  const isSaticiVeyaAdmin = hesapTuru === "Satıcı" || hesapTuru === "Admin";

  const token = localStorage.getItem("token") || authUser?.Token;
  const headers = useMemo(() => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  }), [token]);

  const [activeTab, setActiveTab] = useState("1");
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  // DB record ID'leri (güncelleme için)
  const [magazaId, setMagazaId] = useState(null);
  const [faturaId, setFaturaId] = useState(null);

  // Form verileri
  const [kisiselForm, setKisiselForm] = useState({
    AD_SOYAD: "",
    CEP_NO: "",
    email: "",
    yeniSifre: "",
    sifreTekrar: "",
  });

  const [magazaForm, setMagazaForm] = useState({
    MAGAZA_ADI: "",
    VERGI_NO: "",
    IL: "",
    ILCE: "",
  });

  const [faturaForm, setFaturaForm] = useState({
    KdvNumber: "",
    VergiDairesi: "",
    Adres: "",
    Iban: "",
    Users_BankAccount_BankName: "",
    Users_BankAccount_HolderName: "",
  });

  // Veri yükleme
  useEffect(() => {
    if (!userId) return;
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const [kulResp, magazaResp, faturaResp] = await Promise.all([
          fetch(`${BASE_URL}/KULLANICILAR?$filter=ID eq ${userId}&$select=ID,AD_SOYAD,CEP_NO,Mail_Adress,HESAP_TURU`, { headers }),
          fetch(`${BASE_URL}/MAGAZALAR?$filter=KULLANICI_ID eq ${userId}&$top=1`, { headers }),
          fetch(`${BASE_URL}/FATURA_BILGILERI?$filter=KULLANICI_ID eq ${userId}&$top=1`, { headers }),
        ]);

        const [kulData, magazaData, faturaData] = await Promise.all([
          kulResp.json(), magazaResp.json(), faturaResp.json()
        ]);

        const kul = kulData.value?.[0];
        if (kul) {
          setKisiselForm(prev => ({
            ...prev,
            AD_SOYAD: kul.AD_SOYAD || "",
            CEP_NO: kul.CEP_NO || "",
            email: kul.Mail_Adress || "",
          }));
        }

        const magaza = magazaData.value?.[0];
        if (magaza) {
          setMagazaId(magaza.ID);
          setMagazaForm({
            MAGAZA_ADI: magaza.MAGAZA_ADI || "",
            VERGI_NO: magaza.VERGI_NO || "",
            IL: magaza.IL || "",
            ILCE: magaza.ILCE || "",
          });
        }

        const fatura = faturaData.value?.[0];
        if (fatura) {
          setFaturaId(fatura.ID);
          setFaturaForm({
            KdvNumber: fatura.KdvNumber || "",
            VergiDairesi: fatura.VergiDairesi || "",
            Adres: fatura.Adres || "",
            Iban: fatura.Iban || "",
            Users_BankAccount_BankName: fatura.Users_BankAccount_BankName || "",
            Users_BankAccount_HolderName: fatura.Users_BankAccount_HolderName || "",
          });
        }
      } catch {
        toast.error("Bilgiler yüklenirken hata oluştu.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [userId]);

  // Kişisel bilgileri kaydet
  const saveKisisel = async () => {
    if (!kisiselForm.AD_SOYAD.trim()) {
      toast.warning("Ad Soyad boş bırakılamaz.");
      return;
    }
    if (kisiselForm.yeniSifre && kisiselForm.yeniSifre !== kisiselForm.sifreTekrar) {
      toast.warning("Şifreler eşleşmiyor.");
      return;
    }
    setIsSaving(true);
    try {
      const payload = {
        AD_SOYAD: kisiselForm.AD_SOYAD,
        CEP_NO: kisiselForm.CEP_NO,
      };
      if (kisiselForm.yeniSifre.trim()) {
        payload.Hash_Sifre = kisiselForm.yeniSifre;
      }
      const resp = await fetch(`${BASE_URL}/KULLANICILAR(${userId})`, {
        method: "PATCH",
        headers,
        body: JSON.stringify(payload),
      });
      if (!resp.ok) throw new Error();

      // localStorage'daki authUser'ı da güncelle
      const updatedAuth = { ...authUser, AD_SOYAD: kisiselForm.AD_SOYAD };
      localStorage.setItem("authUser", JSON.stringify(updatedAuth));

      setKisiselForm(prev => ({ ...prev, yeniSifre: "", sifreTekrar: "" }));
      toast.success("Kişisel bilgiler kaydedildi.");
    } catch {
      toast.error("Kaydetme sırasında hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };

  // Mağaza bilgilerini kaydet
  const saveMagaza = async () => {
    setIsSaving(true);
    try {
      if (magazaId) {
        await fetch(`${BASE_URL}/MAGAZALAR(${magazaId})`, {
          method: "PATCH",
          headers,
          body: JSON.stringify(magazaForm),
        });
      } else {
        const resp = await fetch(`${BASE_URL}/MAGAZALAR`, {
          method: "POST",
          headers,
          body: JSON.stringify({ ...magazaForm, KULLANICI_ID: userId }),
        });
        const created = await resp.json();
        if (created?.ID) setMagazaId(created.ID);
      }
      toast.success("Mağaza bilgileri kaydedildi.");
    } catch {
      toast.error("Kaydetme sırasında hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };

  // Fatura bilgilerini kaydet
  const saveFatura = async () => {
    setIsSaving(true);
    try {
      const payload = { ...faturaForm, KULLANICI_ID: userId };
      if (faturaId) {
        await fetch(`${BASE_URL}/FATURA_BILGILERI(${faturaId})`, {
          method: "PATCH",
          headers,
          body: JSON.stringify(payload),
        });
      } else {
        const resp = await fetch(`${BASE_URL}/FATURA_BILGILERI`, {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        });
        const created = await resp.json();
        if (created?.ID) setFaturaId(created.ID);
      }
      toast.success("Fatura/banka bilgileri kaydedildi.");
    } catch {
      toast.error("Kaydetme sırasında hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };

  const handleSave = () => {
    if (activeTab === "1") saveKisisel();
    else if (activeTab === "2") saveMagaza();
    else if (activeTab === "3") saveFatura();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Hesap" breadcrumbItem="Hesabım" />

          <Row>
            <Col lg="12">
              <Card className="shadow-sm">
                {/* Üst başlık */}
                <CardBody className="border-bottom pb-3">
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white fw-bold"
                      style={{ width: 52, height: 52, fontSize: 20 }}
                    >
                      {(authUser?.AD_SOYAD || "?")[0].toUpperCase()}
                    </div>
                    <div>
                      <h5 className="mb-0">{authUser?.AD_SOYAD || "-"}</h5>
                      <div className="d-flex align-items-center gap-2 mt-1">
                        <Badge color={hesapTuru === "Admin" ? "danger" : hesapTuru === "Satıcı" ? "success" : "primary"}>
                          {hesapTuru}
                        </Badge>
                        <small className="text-muted">{authUser?.Mail_Adress}</small>
                      </div>
                    </div>
                  </div>
                </CardBody>

                {/* Sekmeler */}
                <CardBody className="pt-0 pb-0 border-bottom">
                  <Nav tabs className="nav-tabs-custom border-bottom-0">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" })}
                        onClick={() => setActiveTab("1")}
                        style={{ cursor: "pointer" }}
                      >
                        <i className="bx bx-user me-1" />Kişisel Bilgiler
                      </NavLink>
                    </NavItem>
                    {isSaticiVeyaAdmin && (
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "2" })}
                          onClick={() => setActiveTab("2")}
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bx bx-store me-1" />Mağaza Bilgileri
                        </NavLink>
                      </NavItem>
                    )}
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" })}
                        onClick={() => setActiveTab("3")}
                        style={{ cursor: "pointer" }}
                      >
                        <i className="bx bx-receipt me-1" />Fatura & Banka
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardBody>

                <CardBody>
                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TabContent activeTab={activeTab}>

                      {/* ── SEKME 1: KİŞİSEL BİLGİLER ── */}
                      <TabPane tabId="1">
                        <div className="mt-3" style={{ maxWidth: 560 }}>
                          <FormGroup row className="mb-3">
                            <Label sm={3} className="fw-medium">Ad Soyad</Label>
                            <Col sm={9}>
                              <Input
                                value={kisiselForm.AD_SOYAD}
                                onChange={e => setKisiselForm(p => ({ ...p, AD_SOYAD: e.target.value }))}
                                placeholder="Ad Soyad"
                              />
                            </Col>
                          </FormGroup>
                          <FormGroup row className="mb-3">
                            <Label sm={3} className="fw-medium">Telefon</Label>
                            <Col sm={9}>
                              <Input
                                value={kisiselForm.CEP_NO}
                                onChange={e => setKisiselForm(p => ({ ...p, CEP_NO: e.target.value }))}
                                placeholder="05XX XXX XX XX"
                              />
                            </Col>
                          </FormGroup>
                          <FormGroup row className="mb-3">
                            <Label sm={3} className="fw-medium">E-posta</Label>
                            <Col sm={9}>
                              <Input value={kisiselForm.email} disabled className="bg-light" />
                              <small className="text-muted">E-posta adresi değiştirilemez.</small>
                            </Col>
                          </FormGroup>
                          <hr />
                          <h6 className="text-muted mb-3">Şifre Değiştir <small>(değiştirmek istemiyorsanız boş bırakın)</small></h6>
                          <FormGroup row className="mb-3">
                            <Label sm={3} className="fw-medium">Yeni Şifre</Label>
                            <Col sm={9}>
                              <Input
                                type="password"
                                value={kisiselForm.yeniSifre}
                                onChange={e => setKisiselForm(p => ({ ...p, yeniSifre: e.target.value }))}
                                placeholder="En az 6 karakter"
                              />
                            </Col>
                          </FormGroup>
                          <FormGroup row className="mb-3">
                            <Label sm={3} className="fw-medium">Tekrar</Label>
                            <Col sm={9}>
                              <Input
                                type="password"
                                value={kisiselForm.sifreTekrar}
                                onChange={e => setKisiselForm(p => ({ ...p, sifreTekrar: e.target.value }))}
                                placeholder="Şifreyi tekrar girin"
                              />
                              {kisiselForm.yeniSifre && kisiselForm.sifreTekrar && kisiselForm.yeniSifre !== kisiselForm.sifreTekrar && (
                                <small className="text-danger">Şifreler eşleşmiyor.</small>
                              )}
                            </Col>
                          </FormGroup>
                        </div>
                      </TabPane>

                      {/* ── SEKME 2: MAĞAZA BİLGİLERİ ── */}
                      {isSaticiVeyaAdmin && (
                        <TabPane tabId="2">
                          <div className="mt-3" style={{ maxWidth: 560 }}>
                            {!magazaId && (
                              <Alert color="info" className="mb-3">
                                <i className="bx bx-info-circle me-2" />
                                Henüz mağaza kaydınız yok. Bilgileri doldurup kaydedin.
                              </Alert>
                            )}
                            <FormGroup row className="mb-3">
                              <Label sm={3} className="fw-medium">Mağaza Adı</Label>
                              <Col sm={9}>
                                <Input
                                  value={magazaForm.MAGAZA_ADI}
                                  onChange={e => setMagazaForm(p => ({ ...p, MAGAZA_ADI: e.target.value }))}
                                  placeholder="Mağazanızın adı"
                                />
                              </Col>
                            </FormGroup>
                            <FormGroup row className="mb-3">
                              <Label sm={3} className="fw-medium">Vergi No</Label>
                              <Col sm={9}>
                                <Input
                                  value={magazaForm.VERGI_NO}
                                  onChange={e => setMagazaForm(p => ({ ...p, VERGI_NO: e.target.value }))}
                                  placeholder="Vergi numaranız"
                                />
                              </Col>
                            </FormGroup>
                            <FormGroup row className="mb-3">
                              <Label sm={3} className="fw-medium">İl</Label>
                              <Col sm={9}>
                                <Input
                                  value={magazaForm.IL}
                                  onChange={e => setMagazaForm(p => ({ ...p, IL: e.target.value }))}
                                  placeholder="İl"
                                />
                              </Col>
                            </FormGroup>
                            <FormGroup row className="mb-3">
                              <Label sm={3} className="fw-medium">İlçe</Label>
                              <Col sm={9}>
                                <Input
                                  value={magazaForm.ILCE}
                                  onChange={e => setMagazaForm(p => ({ ...p, ILCE: e.target.value }))}
                                  placeholder="İlçe"
                                />
                              </Col>
                            </FormGroup>
                          </div>
                        </TabPane>
                      )}

                      {/* ── SEKME 3: FATURA & BANKA ── */}
                      <TabPane tabId="3">
                        <div className="mt-3" style={{ maxWidth: 560 }}>
                          <h6 className="text-muted mb-3 border-bottom pb-2">Vergi / Fatura Bilgileri</h6>
                          <FormGroup row className="mb-3">
                            <Label sm={3} className="fw-medium">KDV / Vergi No</Label>
                            <Col sm={9}>
                              <Input
                                value={faturaForm.KdvNumber}
                                onChange={e => setFaturaForm(p => ({ ...p, KdvNumber: e.target.value }))}
                                placeholder="Vergi numaranız"
                              />
                            </Col>
                          </FormGroup>
                          <FormGroup row className="mb-3">
                            <Label sm={3} className="fw-medium">Vergi Dairesi</Label>
                            <Col sm={9}>
                              <Input
                                value={faturaForm.VergiDairesi}
                                onChange={e => setFaturaForm(p => ({ ...p, VergiDairesi: e.target.value }))}
                                placeholder="Bağlı olduğunuz vergi dairesi"
                              />
                            </Col>
                          </FormGroup>
                          <FormGroup row className="mb-3">
                            <Label sm={3} className="fw-medium">Fatura Adresi</Label>
                            <Col sm={9}>
                              <Input
                                type="textarea"
                                rows={2}
                                value={faturaForm.Adres}
                                onChange={e => setFaturaForm(p => ({ ...p, Adres: e.target.value }))}
                                placeholder="Faturada görünecek adres"
                              />
                            </Col>
                          </FormGroup>

                          <h6 className="text-muted mb-3 border-bottom pb-2 mt-4">Banka Bilgileri</h6>
                          <FormGroup row className="mb-3">
                            <Label sm={3} className="fw-medium">Hesap Sahibi</Label>
                            <Col sm={9}>
                              <Input
                                value={faturaForm.Users_BankAccount_HolderName}
                                onChange={e => setFaturaForm(p => ({ ...p, Users_BankAccount_HolderName: e.target.value }))}
                                placeholder="Hesap sahibi ad soyad / unvan"
                              />
                            </Col>
                          </FormGroup>
                          <FormGroup row className="mb-3">
                            <Label sm={3} className="fw-medium">Banka Adı</Label>
                            <Col sm={9}>
                              <Input
                                value={faturaForm.Users_BankAccount_BankName}
                                onChange={e => setFaturaForm(p => ({ ...p, Users_BankAccount_BankName: e.target.value }))}
                                placeholder="Örn: Garanti BBVA"
                              />
                            </Col>
                          </FormGroup>
                          <FormGroup row className="mb-3">
                            <Label sm={3} className="fw-medium">IBAN</Label>
                            <Col sm={9}>
                              <Input
                                value={faturaForm.Iban}
                                onChange={e => setFaturaForm(p => ({ ...p, Iban: e.target.value }))}
                                placeholder="TR..."
                              />
                            </Col>
                          </FormGroup>
                        </div>
                      </TabPane>

                    </TabContent>
                  )}

                  {/* Kaydet butonu */}
                  {!isLoading && (
                    <div className="border-top pt-4 mt-4">
                      <Button color="primary" onClick={handleSave} disabled={isSaving} className="px-4">
                        {isSaving ? <Spinner size="sm" className="me-2" /> : <i className="bx bx-save me-2" />}
                        Kaydet
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer autoClose={2000} />
    </React.Fragment>
  );
};

export default Hesabim;
